import { AxiosResponse } from 'axios';
import $api from '@/http/index';

export class EnvironmentService {
    private static extendDataCache = new Map<string, { promise: Promise<AxiosResponse<any[]>>; timestamp: number }>();
    private static readonly CACHE_LIFETIME_MS = 60 * 1000; // 60 seconds

    static async offsetWorkDay(date: Date, offset: number): Promise<AxiosResponse<Date>> {
        let d = date.toISOString();
        return $api.get<Date>(`/Environment/OffsetWorkDay/${d}/${offset}`);
    }

    static async lastWorkDayAfterOffset(
        date: Date,
        offset: number,
        allowedWeekDays: number[],
    ): Promise<AxiosResponse<Date>> {
        let d = date.toISOString();
        return $api.get<Date>(`/Environment/LastWorkDayAfterOffset/${d}/${offset}`, {
            params: {
                allowedWeekDays: allowedWeekDays,
            },
        });
    }

    static async getExtendData(key: string, params: string, encrypted: boolean = false): Promise<AxiosResponse<any[]>> {
        const cacheKey = `${key}|${params}|${encrypted}`;
        const now = Date.now();

        const cached = this.extendDataCache.get(cacheKey);
        if (cached && now - cached.timestamp < this.CACHE_LIFETIME_MS) {
            // cache hit
            return cached.promise;
        }

        if (cached) {
            // cache expired
            this.extendDataCache.delete(cacheKey);
        }

        // Create and cache the promise with timestamp
        const promise = $api
            .post(`/Environment/GetExtendData/${key}/${encrypted}`, { param: params })
            .catch((error) => {
                // Remove failed promise from cache so it can be retried
                this.extendDataCache.delete(cacheKey);
                throw error;
            });

        this.extendDataCache.set(cacheKey, { promise, timestamp: now });

        return promise;
    }

    static async getExtendDataPost(request: {
        procedureName: string;
        encrypted?: boolean;
        params: Record<string, any>;
    }): Promise<AxiosResponse<any[]>> {
        return $api.post('/Environment/GetExtendData', request);
    }
}
